import axios from './request'
import { prop } from 'ramda'

/**
 * @typedef ServiceRequestApiParams
 * @property {number} paginate Количество строк на странице (по-умолчанию - 30)
 * @property {number} page Номер страницы (по-умолчанию - 1)
 * @property {string} brand Id бренда
 * @property {string} city Id города
 * @property {number} change Количество дней сколько не менялась заявка
 * @property {number} status Id статуса
 * @property {string} requestNumber Строка которая входит в номер заявки
 * @property {string} serialNumber Строка которая входит в серийный номер
 * @property {string} dateStart Начало периода даты для фильтра
 * @property {string} dateEnd Конец периода даты для фильтра
 */

/**
 * @typedef ServiceRequest
 * @property {string} ID
 * @property {string} PHONE
 * @property {string} FULL_NAME
 * @property {string} MODEL
 * @property {string} BRAND
 * @property {string} STATUS
 * @property {number} ACTS
 * @property {string} CITY
 * @property {string[]} REPORTS
 * @property {string} SERIAL_NUMBER
 * @property {string} TRACKS
 */

/**
 *
 * @param {ServiceRequestApiParams} params
 * @param {import('axios').AxiosRequestConfig?} config
 * @returns {Promise<{ items: ServiceRequest[], total: number}>}
 */
export default function getServiceRequests(params, config) {
	return axios.get('/api/Requests/getList/', {
		...config,
		params,
	})
		.then(({ data }) => data)
		.then(prop('data'))
}
